import { MSALInfo } from '../types.ts';

const getAccessToken = async (
    clientId: string,
    { instance, accounts }: MSALInfo,
    requiresAuthentication: boolean
) => {
    if (!requiresAuthentication) {
        return null;
    }

    const request = {
        scopes: [`${clientId}/.default`],
        account: accounts[0]
    };

    try {
        const response = await instance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        console.error('Failed to acquire token silently', error);
        try {
            const response = await instance.acquireTokenPopup(request);
            return response.accessToken;
        } catch (popupError) {
            console.error('Failed to acquire token with popup', popupError);
        }
    }

    return null;
};

export default getAccessToken;
